module.exports = __webpack_public_path__ + "media/images/kozos_ugyunk_BLUE-987f8b0fb8d42a439bdbd93b439b5fb2.jpg";